import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    wallArea: number;
    glassBrickArea: number;
    numberOfGlassBricks: number;
    numberOfGlassBrickCrosses: number;
    mortarVolume: number;
    jointCementVolume: number;
    mailParams: Record<string, string>;
};

const Result = ({
    wallArea,
    glassBrickArea,
    numberOfGlassBricks,
    numberOfGlassBrickCrosses,
    mortarVolume,
    jointCementVolume,
    mailParams
}: Props) => {
    const { t } = useGranite();

    // cement
    const cementInKg = Number(mortarVolume * 300 * 1.1);
    const sandInKg = Number(mortarVolume * 1500 * 1.1);
    const water = Number(mortarVolume * 150);
    const cementInBagsOf25Kg = Number(Math.ceil(cementInKg / 25));
    const sandInBagsOf25Kg = Number(Math.ceil(sandInKg / 25));

    // jointCement single side
    const jointCementInKg = Number(jointCementVolume * 350 * 1.1);
    const jointSandInKg = Number(jointCementVolume * 1500 * 1.1);
    const jointWater = Number(jointCementVolume * 175);
    const jointCementInBagsOf25Kg = Number(Math.ceil(jointCementInKg / 25));
    const jointSandInBagsOf25Kg = Number(Math.ceil(jointSandInKg / 25));

    return (
        <div className={"mt-4"}>
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    copy={t("calculator.glassbrickCalculator.wallArea")}
                    value={wallArea.toFixed(2)}
                    unit={"m"}
                    sup={2}
                    md={6}
                    lg={3}
                />
                <ResultField
                    copy={t(
                        "calculator.glassbrickCalculator.numberOfGlassbricks"
                    )}
                    value={numberOfGlassBricks.toFixed(0)}
                    md={6}
                    lg={3}
                />
            </Row>
            <Row>
                <ResultField
                    copy={t("calculator.glassbrickCalculator.glassbrickArea")}
                    value={glassBrickArea.toFixed(2)}
                    unit={"m"}
                    sup={2}
                    md={6}
                    lg={3}
                />
                <ResultField
                    copy={t(
                        "calculator.glassbrickCalculator.numberOfGlassbrickCrosses"
                    )}
                    value={numberOfGlassBrickCrosses.toFixed(0)}
                    md={6}
                    lg={3}
                />
            </Row>
            <Row>
                <Col sm={6}>
                    <h4 className="d-sm-block">
                        {t("calculator.glassbrickCalculator.grout")}
                    </h4>
                    <Row>
                        <ResultField
                            copy={t("calculator.volumeNeeded")}
                            value={mortarVolume.toFixed(2)}
                            unit={"m"}
                            sup={3}
                            lg={6}
                        />
                    </Row>
                    <Row className={"calculator-group"}>
                        <ResultField
                            copy={t("calculator.cement")}
                            value={cementInKg.toFixed(2)}
                            md={6}
                            unit={"kg"}
                        />
                        <ResultField
                            copy={t("calculator.nrBags25Kg")}
                            value={cementInBagsOf25Kg.toFixed(0)}
                            md={6}
                        />
                    </Row>
                    <Row className={"calculator-group"}>
                        <ResultField
                            copy={t("calculator.rhineSand")}
                            value={sandInKg.toFixed(2)}
                            md={6}
                            unit={"kg"}
                        />
                        <ResultField
                            copy={t("calculator.nrBags25Kg")}
                            value={sandInBagsOf25Kg.toFixed(0)}
                            md={6}
                        />
                    </Row>
                    <Row>
                        <ResultField
                            copy={t("calculator.water")}
                            value={water.toFixed(2)}
                            md={6}
                            unit={"l"}
                        />
                    </Row>
                </Col>
                <Col sm={6}>
                    <h4 className="d-sm-block">
                        {t("calculator.glassbrickCalculator.jointCement")}
                    </h4>
                    <Row>
                        <ResultField
                            copy={t("calculator.volumeNeeded")}
                            value={jointCementVolume.toFixed(2)}
                            unit={"m"}
                            sup={3}
                            lg={6}
                        />
                    </Row>
                    <Row className={"calculator-group"}>
                        <ResultField
                            copy={t("calculator.cement")}
                            value={jointCementInKg.toFixed(2)}
                            md={6}
                            unit={"kg"}
                        />
                        <ResultField
                            copy={t("calculator.nrBags25Kg")}
                            value={jointCementInBagsOf25Kg.toFixed(0)}
                            md={6}
                        />
                    </Row>
                    <Row className={"calculator-group"}>
                        <ResultField
                            copy={t("calculator.whiteSand")}
                            value={jointSandInKg.toFixed(2)}
                            md={6}
                            unit={"kg"}
                        />
                        <ResultField
                            copy={t("calculator.nrBags25Kg")}
                            value={jointSandInBagsOf25Kg.toFixed(0)}
                            md={6}
                        />
                    </Row>
                    <Row>
                        <ResultField
                            copy={t("calculator.water")}
                            value={jointWater.toFixed(2)}
                            md={6}
                            unit={"l"}
                        />
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default Result;
